import {InputField, ProviderIntegrationApi, ProviderIntegrationApiFromJSON} from "@enter/core";
import React, { useMemo } from 'react';
import {Formik, FormikHelpers, FormikProps, Form, Field} from "formik";
import * as Yup from "yup";
import * as S from './api-key-modal.styles';
import * as SH from '../shared.styles';

import _ from "lodash";

type FormProps = {
    name: string;
}

type IApiKeyModalProps = {
    onSubmit: (name: string) => Promise<void>;
    onClose: () => void;
};

const ApiKeySchema = Yup.object().shape({
    name: Yup.string().required('Name is required')
});


export const ApiKeyModal = ({onSubmit, onClose}: IApiKeyModalProps) => {

    const onFormSubmit = async (values: FormProps, formik: FormikHelpers<FormProps>) => {
        formik.setSubmitting(true);
        try {
            await onSubmit(values.name);
        } finally {
            formik.setSubmitting(false);
        }
    };

    const initialValues: FormProps = useMemo(() => {
        return {
            name: 'API Key Name'
        };
    }, []);

    return (
        <Formik initialValues={initialValues} validationSchema={ApiKeySchema} onSubmit={onFormSubmit}>
            {(formik: FormikProps<FormProps>) => (
                <S.DialogBody>
                    <S.InputGroup>
                        <S.Label>API Key Name</S.Label>
                        <S.FormField name="name" maxLength={30} component={InputField} />
                    </S.InputGroup>
                    <S.ButtonGroup
                        changed={true}
                        useNotify={false}
                        onCancel={onClose}
                        onSave={formik.submitForm}
                        saveLabel="Save"
                    />
                </S.DialogBody>
            )}
        </Formik>
    );
};